import React, { useMemo } from "react";
import { createStaticRanges, DateRangePicker } from "react-date-range";
import { definedsDates } from "./config";
import { isAfter } from "date-fns";
import { ptBR } from "date-fns/locale";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const Calendar = ({ onChange, ranges, minDate, removeOptions = [], alternativeOptions, maxDate }) => {
  const actualDate = new Date();

  const memoizedDatesStatics = useMemo(() => {
    const allStaticDates = [
      {
        option: 1,
        label: "Hoje",
        range: () => ({
          startDate: definedsDates.startOfToday,
          endDate: definedsDates.endOfToday
        })
      },
      {
        option: 2,
        label: "Últimos 7 Dias",
        range: () => ({
          startDate: definedsDates.startOfLastSevenDay,
          endDate: definedsDates.endOfToday
        })
      },
      {
        option: 3,
        label: "Últimos 30 Dias",
        range: () => ({
          startDate: definedsDates.startOfLastThirtyDay,
          endDate: definedsDates.endOfToday
        })
      },
      {
        option: 4,
        label: "Últimos 90 Dias",
        range: () => ({
          startDate: definedsDates.startOfLastNintyDay,
          endDate: definedsDates.endOfToday
        })
      },
      {
        option: 5,
        label: "Esta Semana",
        range: () => ({
          startDate: definedsDates.startOfWeek,
          endDate: isAfter(definedsDates.endOfWeek, actualDate)
            ? actualDate
            : definedsDates.endOfWeek
        })
      },
      {
        option: 6,
        label: "Última Semana",
        range: () => ({
          startDate: definedsDates.startOfLastWeek,
          endDate: definedsDates.endOfLastWeek
        })
      },
      {
        option: 7,
        label: "Mês Atual",
        range: () => ({
          startDate: definedsDates.startOfMonth,
          endDate: isAfter(definedsDates.endOfMonth, actualDate)
            ? actualDate
            : definedsDates.endOfMonth
        })
      },
      {
        option: 8,
        label: "Último Mês",
        range: () => ({
          startDate: definedsDates.startOfLastMonth,
          endDate: definedsDates.endOfLastMonth
        })
      },
      {
        option: 9,
        label: "Últimos 3 Meses",
        range: () => ({
          startDate: definedsDates.startOfLast3Months,
          endDate: definedsDates.endOfLastMonth
        })
      },
      {
        option: 10,
        label: "Últimos 6 Meses",
        range: () => ({
          startDate: definedsDates.startOfLast6Months,
          endDate: definedsDates.endOfLastMonth
        })
      },
      {
        option: 11,
        label: "Ano Atual",
        range: () => ({
          startDate: definedsDates.startOfYear,
          endDate: isAfter(definedsDates.endOfYear, actualDate)
            ? actualDate
            : definedsDates.endOfYear
        })
      },
      {
        option: 12,
        label: "Ano passado",
        range: () => ({
          startDate: definedsDates.startOflastYear,
          endDate: definedsDates.endOflastYear
        })
      },
    ];
    const options = allStaticDates.filter(
      (date) => !removeOptions.includes(date.option)
    );

    return createStaticRanges(alternativeOptions ?? options);
  }, [actualDate]);

  const screenWidth = window.innerWidth;
  return (
    <DateRangePicker
      direction={screenWidth > 1124 ? "horizontal" : "vertical"}
      months={2}
      onChange={onChange}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      ranges={ranges}
      color="#409e6a"
      inputRanges={[]}
      rangeColors={["#409e6a"]}
      staticRanges={memoizedDatesStatics}
      minDate={minDate}
      maxDate={maxDate ?? actualDate}
      weekdayDisplayFormat="EEEEEE"
      locale={ptBR}
    />
  );
};

export { Calendar };
